import { generateId } from '@freelancer/datastore/testing/helpers';
import type { BidProjectMatchRank } from './bid-project-match-rank.model';

export interface GenerateBidProjectMatchRankOptions {
  readonly id?: number;
  readonly projectId: number;
  readonly bidRank: number;
  readonly weightedIntentRelevancyScore: number;
}

export function generateBidProjectMatchRankObject({
  id = generateId(),
  projectId,
  bidRank,
  weightedIntentRelevancyScore,
}: GenerateBidProjectMatchRankOptions): BidProjectMatchRank {
  return {
    id,
    projectId,
    bidRank,
    weightedIntentRelevancyScore,
  };
}
